<template>
  <div class="min-h-screen">
    <div
      v-if="loading || tableData.length === 0"
      class="flex flex-col justify-center items-center h-full mt-5"
    >
      <el-empty :image-size="70" description="No Data"></el-empty>
    </div>
    <div v-else class="m-3 rounded-md bg-white p-2">
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "Holidays",

  data() {
    return {
      loading: false,
      get_error: null,
      columns: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        { field: "Name", key: "Name", title: "Holiday Name", align: "left" },
        {
          field: "ISO",
          key: "ISO",
          title: "Date",
          renderBodyCell: ({ row }) => moment(row.ISO).format("DD/MM/YYYY"),
        },
        { field: "PrimaryType", key: "PrimaryType", title: "Type" },
        {
          field: "Description",
          key: "Description",
          title: "Description",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
        },

        { field: "ApplicableTo", key: "c", title: "Applicable To" },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                >
                  Edit
                </button>

                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.assign(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getToken", "getOrganization"]),
  },
  created() {
    this.getHolidays();
  },

  methods: {
    // /{organization}/holiday/v1/request
    getHolidays() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/holiday/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
              // console.log(this.tableData);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped></style>
